import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { GuardarNuevoTipoActivo } from '../../helpers/ActivosHelper';
import { TiposActivoContext } from '../../pages/catalogos/ActivosTipoPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregaTipoActivoComponent = () => {
    const {modalAgregaTipoActivo, setModalAgregaTipoActivo, obtenerTipos, tipoActivoSel} = useContext(TiposActivoContext);
    const [tipoActivo, setTipoActivo] = useState();
    const [idTipoInstalacion, setIdTipoInstalacion] = useState(0);
    const [errorGuardado, setErrorGuardado] = useState(false);
    const refForm = useRef();
    console.log('Valor de modal agrega', modalAgregaTipoActivo);

    const handleClose = () => {
        setModalAgregaTipoActivo(false);
    }

    const verificaAccion = () => {
      if(tipoActivoSel?.IdTipoInstalacion) {
        console.log('Editanto tipo de instalacion', tipoActivoSel);
        setTipoActivo(tipoActivoSel?.TipoInstalacion) ;
        setIdTipoInstalacion(tipoActivoSel?.IdTipoInstalacion);
        
      } else {
        console.log('Agregando tipo de instalacion')
        setTipoActivo('') ;

      }
    }

    useEffect(() => {
      verificaAccion();
    },[tipoActivoSel])
    

    const handleSubmit =  (event) => {
        event.preventDefault();
        //refForm.current.isValidate();
        GuardarNuevoTipoActivo(tipoActivo, idTipoInstalacion).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerTipos();
                handleClose();

            }
        })
    }

  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalAgregaTipoActivo} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>Tipo de Instalación</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="txtTipoActivo"
            label="Descricipción del tipo de instalación"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => setTipoActivo(e.target.value)}
            value={tipoActivo}
          />
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
